module.exports = __webpack_public_path__ + "img/locked.3bffe794.svg";